import { Box } from "@chakra-ui/react";
import { VStack } from "goi_common";
import FacilityQuotationRequest from "./FacilityQuotationRequest";

export default function FacilityMatchRequestSection() {
  return (
    <VStack>
      <VStack gap="10px" padding="18px 24px 0">
        <Box className="head2_b black">장지 추천받기</Box>
      </VStack>
      <VStack>
        <FacilityQuotationRequest onlyFacility />
      </VStack>
    </VStack>
  );
}
